import { useContext } from 'react';

import { TimeseriesMinMaxXAxisContext } from '../context/TimeseriesMinMaxXAxis.context.js';

export const useMinMaxXAxis = () => useContext(TimeseriesMinMaxXAxisContext);
